<nz-layout class="app-import">
    <nz-content class="content">
        <nz-layout>
            <nz-content class="body">
                <div fxLayout="row" class="mb-1" class="w-100">
                    <div fxLayout="col" fxFlex.gt-md="80" fxFlex.lt-md="80" fxLayoutAlign="start center" class="w-100">
                        <div fxLayout="col" fxFlex="15" fxLayoutAlign="start center">
                            Import using URL:
                        </div>
                        <div fxLayout="col" fxFlex="85" fxLayoutAlign="start center">
                            <nz-input-group [nzAddOnBefore]="addOnBeforeTemplate">
                                <input type="text" nz-input [(ngModel)]="inputValue" />
                            </nz-input-group>
                            <ng-template #addOnBeforeTemplate>
                                <nz-select [(ngModel)]="prefix">
                                    <nz-option nzLabel="Http://" nzValue="Http://"></nz-option>
                                    <nz-option nzLabel="Https://" nzValue="Https://"></nz-option>
                                </nz-select>
                            </ng-template>
                        </div>
                    </div>
                    <div fxLayout="col" fxFlex.gt-md="20" fxFlex.lt-md="20" fxLayoutAlign="start center" class="import">

                        <button nz-button nzType="primary" style="color: black;
                        background: white !important;
                        border-color: black !important;
                      " (click)="importByLink()" [nzLoading]="isLoading">Import</button>
                    </div>

                </div>

                <div fxLayout="row" class="mb-1 or-row">
                    <div fxLayout="col" fxFlex="70" fxLayoutAlign="start center" class="or">
                        <div fxLayout="col" fxFlex="15" fxLayoutAlign="center center" class="bold">
                            or
                        </div>
                    </div>
                </div>

                <div fxLayout="row" class="mb-1 " class="w-100">
                    <div fxLayout="col" fxFlex.gt-md="80" fxFlex.lt-md="80" fxLayoutAlign="start center" class="w-100">
                        <div fxLayout="col" fxFlex="15" fxLayoutAlign="start center">
                            Upload XML file:
                        </div>
                        <div fxLayout="col" fxFlex="85" fxLayoutAlign="start center">
                            <nz-upload [(nzFileList)]="fileList" nzAccept=".xml"
                                [nzHeaders]="{ authorization: 'authorization-text' }" [nzBeforeUpload]="beforeUpload">
                                <button nz-button nzType="primary" style="color: black;
                                background: white !important;
                                border-color: black !important;
                              ">
                                    <span nz-icon nzType="upload"></span>
                                    Upload XML file
                                </button>
                            </nz-upload>
                        </div>
                    </div>
                    <div fxLayout="col" fxFlex.gt-md="20" fxFlex.lt-md="20" fxLayoutAlign="start center" class="import">

                        <button nz-button nzType="primary" style="color: black;
                        background: white !important;
                        border-color: black !important;
                      " (click)="handleChange()" [nzLoading]="isLoading"
                            [disabled]="fileList.length == 0">Import</button>
                    </div>

                </div>

            </nz-content>
        </nz-layout>
    </nz-content>
</nz-layout>